type CardProps = {
    children: React.ReactNode;
    className?: string;
};

export function Card({ children, className }: CardProps) {
    return (
        <div
            className={`space-y-6 p-6 ns:rounded-2xl ns:bg-white ${className}`}
        >
            {children}
        </div>
    );
}
